import { ColumnConfig } from "components/Table/types";
import { TableColumnMeta } from "ds/components/Table/types";

export const COMPUTED_VALUE = "<computed>";
export const EMPTY_VALUE = "<empty>";
export const WRITE_ONLY_VALUE = "*****";

export enum EnvVariablesColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  VALUE = "value",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = "actions",
}

export enum FilesColumnId {
  EXPAND = "expand",
  NAME = "name",
  DESCRIPTION = "description",
  SECRET = "secret",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = "actions",
}

export enum ContextColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  ACTIONS = "actions",
}

export const ENV_VARS_COLUMNS: Record<string, TableColumnMeta> = {
  [EnvVariablesColumnId.NAME]: {
    id: EnvVariablesColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.DESCRIPTION]: {
    id: EnvVariablesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.VALUE]: {
    id: EnvVariablesColumnId.VALUE,
    title: "Value",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.SOURCE]: {
    id: EnvVariablesColumnId.SOURCE,
    title: "Source",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.CREATED_AT]: {
    id: EnvVariablesColumnId.CREATED_AT,
    title: "Created at",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};

export const SPACELIFT_VARS_COLUMNS: Record<string, TableColumnMeta> = {
  [EnvVariablesColumnId.NAME]: {
    id: EnvVariablesColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.DESCRIPTION]: {
    id: EnvVariablesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.VALUE]: {
    id: EnvVariablesColumnId.VALUE,
    title: "Value",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};

export const MOUNTED_FILES_COLUMNS: Record<string, TableColumnMeta> = {
  [FilesColumnId.EXPAND]: {
    id: FilesColumnId.EXPAND,
    defaultWidth: 40,
    maxWidth: 40,
    minWidth: 40,
    title: "Expand",
    noHeader: true,
    allowsSorting: false,
    resizable: false,
    canHide: false,
  },
  [FilesColumnId.NAME]: {
    id: FilesColumnId.NAME,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Name",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.DESCRIPTION]: {
    id: FilesColumnId.DESCRIPTION,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Description",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.SECRET]: {
    id: FilesColumnId.SECRET,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Secret",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.SOURCE]: {
    id: FilesColumnId.SOURCE,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Source",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.CREATED_AT]: {
    id: FilesColumnId.CREATED_AT,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Created at",
    allowsSorting: false,
    resizable: false,
  },
};

export const CONTEXTS_COLUMNS: Record<string, TableColumnMeta> = {
  [ContextColumnId.NAME]: {
    id: ContextColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [ContextColumnId.DESCRIPTION]: {
    id: ContextColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};

export const CUSTOM_END_COLUMN_CONFIG: ColumnConfig = {
  [EnvVariablesColumnId.ACTIONS]: {
    title: "Actions",
    noHeader: true,
    static: true,
    maxWidth: 40,
    minWidth: 40,
    defaultWidth: 40,
    sticky: true,
    resizable: false,
  },
};
